module.exports = __webpack_public_path__ + "static/media/LogoWorldEconomicForum.cff05423.svg";